import React, { useState } from 'react';
import TopSidebar from '../components/TopSidebar';
import Header from '../components/Header';
import PageHelmet from '../components/helmet/PageHelmet';
import { useTranslation } from 'react-i18next';
import '../css/EwePcWarranty.css';
import MessageInfoBox from '../components/other/MessageInfoBox';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const NewsPage = () => {
    const { t } = useTranslation('newsPage');
    const isDesktop = window.innerWidth > 1020;

    const [serialNumber, setSerialNumber] = useState('');


    const handleClick = async (e) => {
        e.preventDefault();

        if (!serialNumber || !serialNumber.trim()) {
            toast(
                <MessageInfoBox message="serialNumberRequired" type="0" />,
                { className: 'red-background', position: "top-right", autoClose: 3000 }
            );
            return;
        }

        try {
            const data = { serialNumber };

            const url = `${process.env.REACT_APP_API_URL}/decisionController/checkWarranty`;

            const res = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data)
            });

            const response = await res.json();

            toast(
                <MessageInfoBox message="serialNumber" type={response.isOk} />, {
                className: response.isOk == 1 ? 'green-background' : 'red-background',
            });

        } catch (error) {
            console.error(error);
            toast(
                <MessageInfoBox message="globalError" type="0" />,
                { className: 'red-background', position: 'top-right', autoClose: 5000 }
            );
        }
    };

    const handleInputChange = (e) => {
        setSerialNumber(e.target.value);
    };

    return (
        <>
            <PageHelmet
                title={"Ewe PC Garancije"}
                description={"Ewe PC Garancije"}
                keywords={"Ewe PC Garancije"}
                ogDescription={"Ewe PC Garancije"}
                ogTitle={"Ewe PC Garancije"}
                ogUrl={`https://ewe.rs/ewe-pc-garancije`}
                ogImg="https://www.ewe.rs/media/ewe-og-img.jpg"
                twitterDescription={""}
            />
            {!isDesktop ? <Header /> : <TopSidebar />}
            <div className="ewe-pc-warranty-container">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8 col-xl-6">
                            <div className="ewe-pc-warranty-card">
                                <div className="ewe-pc-warranty-header">
                                    <img src="https://resource.ewe.rs/manufacturers/EWE PC AMD.png" alt="Ewe PC Logo" />
                                    <h1 className='ewe-pc-warranty-title'>EWE PC garancija</h1>
                                    <p className='ewe-pc-warranty-subtitle'>
                                        Proverom serijskog broja možete saznati informacije o garanciji vašeg Ewe PC-a.
                                    </p>
                                </div>
                                <form className="ewe-pc-warranty-form" onSubmit={handleClick}>
                                    <div className="ewe-pc-warranty-input-wrapper">
                                        <input
                                            type="text"
                                            className="ewe-pc-warranty-input"
                                            placeholder="Unesite serijski broj"
                                            value={serialNumber}
                                            onChange={handleInputChange}
                                        />
                                        <span className="ewe-pc-warranty-input-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <circle cx="11" cy="11" r="8" />
                                                <path d="m21 21-4.35-4.35" />
                                            </svg>
                                        </span>
                                    </div>

                                    <button type="submit" className="ewe-pc-warranty-button">
                                        Proverite garanciju
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
};

export default NewsPage;
